import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';

export const LiveWebinarApi = {
    joinWebinar: (options?: BaseApiMutationOptions<ApiClient['liveWebinar']['joinWebinar']>) =>
        apiMutationOptions((api) => api.liveWebinar.joinWebinar, options)
};
